import { createItemsData } from '../utils/request.utils'
import { Service } from './base-service'
import { HALApiService } from './hal-api.service'

export const locationLogService = new Service('/storage/location-log', HALApiService, createItemsData)
